import { useEffect, useMemo, useState } from "react";
import { StyledTableWrapper, TableStyles } from "./ResultsTablesStyles";
import { getHeadersForCategory } from "../../utils/headers";
import ResultsTableHeader from "./ResultsTableHeader";
import type {
  DiffTableProps,
  VehicleTableData
} from "@dealer-center/ddc-pages-inventory-archiver-interface";
import { Table } from "@dealer-center/core-components";
import type { TypeSafeTableColumns } from "@dealer-center/core-components";

const DiffTable = (props: DiffTableProps) => {
  const [columns, setColumns] =
    useState<TypeSafeTableColumns<VehicleTableData>>();
  const diffRows = useMemo(() => {
    const diffs: VehicleTableData[] = [];

    props.data.preData.forEach((preItem, index) => {
      const postItem = props.data.postData[index];

      const row: VehicleTableData = {
        key: `diff-${index}`,
        className: "diff-row",
        title: `Vehicle ${index + 1}`
      };
      props.checkedCategories.forEach(category => {
        const keys = getHeadersForCategory(category);
        keys.forEach(key => {
          const preValue = preItem?.[key] ?? "None";
          const postValue = postItem?.[key] ?? "None";

          row[`pre_${key}`] = preValue?.toString();
          row[`post_${key}`] = postValue?.toString();
          // row[key] wont be displayed in the table
          // instead this allows search to work with both pre and post values
          row[key] = `${preValue?.toString()}/${postValue?.toString()}`;
        });
      });
      diffs.push(row);
    });

    return diffs;
  }, [props.data.preData, props.data.postData, props.checkedCategories]);
  useEffect(() => {
    const headers: TypeSafeTableColumns<VehicleTableData> =
      props.checkedCategories.flatMap(category =>
        getHeadersForCategory(category).map((key: string) => ({
          title: key,
          key,
          dataIndex: key as keyof VehicleTableData,
          className: `column-${key?.toLowerCase()}`,
          render: (_: unknown, row: VehicleTableData) => {
            const preValue = row[`pre_${key}`];
            const postValue = row[`post_${key}`];
            if (preValue == postValue || !preValue) {
              return <div className="no-diff">{postValue}</div>;
            }
            return (
              <div className="diff">
                <div style={{ color: "red" }}>{preValue}</div>
                <center>↓</center>
                <div style={{ color: "green" }}>{postValue}</div>
              </div>
            );
          }
        }))
      );
    setColumns(headers);
  }, [props.checkedCategories]);

  return (
    <div>
      <StyledTableWrapper>
        {props.data.postData.length > 0 && (
          <ResultsTableHeader
            checkedCategories={props.checkedCategories}
            data={props.data.preData}
            onToggleHeaders={props.onToggleHeaders}
          />
        )}
        <Table.Table
          sortableColumns
          columns={columns || []}
          currentPageSize={100}
          data={diffRows}
          dataDensity="small"
          displayFilter={true}
          displayPageSizeSelector={true}
          emptyText="No data found"
          highlightOnHover={true}
          scrollX={1475}
          scrollY={1000}
          tableLayout="auto"
        />
        <TableStyles />
      </StyledTableWrapper>
    </div>
  );
};

export default DiffTable;
